'use client';

import { usePathname } from 'next/navigation';

import { AdType } from '../../advertisements/adbutler/utils/types';
import { isRegisteredAdFreePath } from '../../advertisements/freestar/utils/ad-free-registry';
import { FreestarPlacementId } from '../../advertisements/freestar/utils/types';
import { RenderAd } from '../../advertisements/render-ad';

interface FooterAdProps {
	placementId?: FreestarPlacementId;
	zoneId: AdType;
	ipAddress: string;
	isProd: boolean;
}

/**
 * The footer ad, and the padding that goes with it.
 *
 * Split out as a client component on purpose. `Footer` is rendered by a server layout that is
 * shared with monetised routes — `(no-ticker)/layout.tsx` in pickleball, the root layout in
 * team-leagues — and Next never re-renders a shared layout across a client-side navigation. The
 * server-side `adFree` prop is therefore frozen at whatever the previous page decided, which left
 * the slot mounted and serving after navigating into an ad-free page.
 *
 * `usePathname()` here re-runs on every navigation regardless, and returning null unmounts
 * FreestarAdSlot, whose componentWillUnmount calls the vendor's deleteAdSlot. The wrapper goes
 * with it so the spacing matches a hard load of the same URL.
 */
export const FooterAd = ({ placementId, zoneId, ipAddress, isProd }: FooterAdProps) => {
	const pathname = usePathname();

	if (isRegisteredAdFreePath(pathname)) return null;

	return (
		<div className="w-full py-4 sm:py-6 px-4 md:px-8" id="pd-footer-ad">
			<RenderAd
				placementId={placementId}
				zoneId={zoneId}
				pageId={100023}
				place={0}
				ipAddress={ipAddress}
				isProd={isProd}
				containerClassname="mx-0.5 sm:container sm:mx-auto"
			/>
		</div>
	);
};
